/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Google_Drive_Refresh_ErrorInputs */

const en_google_drive_refresh_error = /** @type {(inputs: Google_Drive_Refresh_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not refresh the file list. Please try again.`)
};

const es_google_drive_refresh_error = /** @type {(inputs: Google_Drive_Refresh_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo actualizar la lista de archivos. Inténtalo de nuevo.`)
};

/**
* | output |
* | --- |
* | "Could not refresh the file list. Please try again." |
*
* @param {Google_Drive_Refresh_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const google_drive_refresh_error = /** @type {((inputs?: Google_Drive_Refresh_ErrorInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Google_Drive_Refresh_ErrorInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_google_drive_refresh_error(inputs)
	return en_google_drive_refresh_error(inputs)
});